module.exports = __webpack_public_path__ + "static/icon-674aa6869c743523c69c23058a079ed7.png";